//@ts-nocheck
import Vue from 'vue';
import VueSessionStorage from 'vue-sessionstorage'
Vue.use(VueSessionStorage)